// this is a utility function to make code more testable
// since translateAndFormat is hard to mock
import { translateAndFormat } from "src/app/i18next";

export const i18nAdapter = {
	getTranslateAndFormat(key: string, fmt?: "capitalize" | "uppercase" | "title" | "camelCase"): string {
		return translateAndFormat(key, fmt);
	},
};
